import React from 'react';
// Removed router imports: BrowserRouter, Routes, Route
// Removed HelmetProvider

// Keep Page imports only if App.js remains as a layout shell, otherwise remove.
// For now, keep them to avoid breaking potential internal links if App isn't fully removed yet.
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ArticlePage from './pages/ArticlePage';
import SearchPage from './pages/SearchPage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

// Removed component imports: ScrollToTop, ScrollToTopOnMount, AdRefreshOnRouteChange, SEO
import ErrorPage from './components/ErrorPage';

// Error Boundary Component (Keep)
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({ errorInfo });
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorPage errorInfo={this.state.errorInfo} />;
    }
    return this.props.children;
  }
}

// App component is now minimal. It might not be used by the new entry points.
function App() {
  console.log('App.js loaded (MPA context) - this component should ideally not be directly rendered anymore.');
  // This component no longer renders anything itself.
  // Each page has its own entry point (e.g., homeEntry.js).
  return null;
}

export { ErrorBoundary }; // Export ErrorBoundary for use in page entry points
export default App; // Exporting App, though its direct usage is diminished.

// Old Router logic removed:
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { HelmetProvider } from 'react-helmet-async';

// Pages
// import HomePage from './pages/HomePage';
// import CategoryPage from './pages/CategoryPage';
// import ArticlePage from './pages/ArticlePage';
// import SearchPage from './pages/SearchPage';
// import AboutPage from './pages/AboutPage';
// import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
// import TermsOfServicePage from './pages/TermsOfServicePage';

// Components
// import ScrollToTop from './components/ScrollToTop';
// import ScrollToTopOnMount from './components/ScrollToTopOnMount';
// import AdRefreshOnRouteChange from './components/AdRefreshOnRouteChange';
// import SEO from './components/SEO';
// import ErrorPage from './components/ErrorPage';

// Error Boundary 组件
// class ErrorBoundary extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false, errorInfo: null };
//   }

//   static getDerivedStateFromError(error) {
//     return { hasError: true };
//   }

//   componentDidCatch(error, errorInfo) {
//     this.setState({ errorInfo });
//     console.error('Error caught by ErrorBoundary:', error, errorInfo);
//   }

//   render() {
//     if (this.state.hasError) {
//       return <ErrorPage errorInfo={this.state.errorInfo} />;
//     }
//     return this.props.children;
//   }
// }

// function App() {
//   // 初始化应用时记录时间，保留基本日志功能
//   console.log(`应用初始化开始: ${new Date().toISOString()}`);

//   return (
//     <HelmetProvider>
//       <ErrorBoundary>
//         <Router>
//           <SEO /> {/* 默认全站SEO */}
//           <ScrollToTop />
//           <ScrollToTopOnMount />
//           <AdRefreshOnRouteChange /> {/* 监听路由变化并刷新广告 */}
//           <main className="flex-grow">
//             <Routes>
//               <Route path="/" element={<HomePage />} />
//               <Route path="/category/:category" element={<CategoryPage />} />
//               <Route path="/article/:id" element={<ArticlePage />} />
//               <Route path="/search" element={<SearchPage />} />
//               <Route path="/about-us" element={<AboutPage />} />
//               <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
//               <Route path="/terms-of-service" element={<TermsOfServicePage />} />
//               <Route path="/error" element={<ErrorPage />} />
//               <Route path="*" element={<div>Page not found</div>} />
//             </Routes>
//           </main>
//         </Router>
//       </ErrorBoundary>
//     </HelmetProvider>
//   );
// }

// export default App; 